<template>
  <v-card class="session__container">
    <ChooseLanguage :positionAbsolute="true" />
    <div class="selection-wrapper">
      <div>
        <v-img
          src="@/static/brand_logo.svg"
          class="mx-auto session__logo"
          aspect-ratio
        >
        </v-img>
      </div>
      <h2 class="session__title">
        {{ $t("message.session.accountTypeSelection.signUpAs") }}
      </h2>
      <div class="selection-options">
        <div class="option-card" @click="goToSignUp">
          <div class="option-card__image">
            <img src="@/static/session/company.svg" />
          </div>
          <div class="option-card__title option-card__title--highlighted">
            {{ $t("message.session.accountTypeSelection.company") }}
          </div>
          <div class="option-card__text">
            {{ $t("message.session.accountTypeSelection.companyOwnerText") }}
          </div>
        </div>
        <div class="option-card" @click="goToEmployee">
          <div class="option-card__image">
            <img src="@/static/session/employee.svg" />
          </div>
          <div class="option-card__title">
            {{ $t("message.session.accountTypeSelection.employee") }}
          </div>
          <div class="option-card__text">
            {{ $t("message.session.accountTypeSelection.employeeText") }}
          </div>
        </div>
      </div>
      <p class="selection-wrapper__text">
        {{ $t("message.session.accountTypeSelection.ifHaveAnAccount") }}
      </p>
      <v-btn
        large
        block
        color="primary"
        class="submit-button"
        :to="{ name: 'session-login' }"
      >
        {{ $t("message.common.login") }}
      </v-btn>
    </div></v-card
  >
</template>

<script>
import ChooseLanguage from "@/components/AppBar/ChooseLanguage.vue";
const PRICING_URLS = {
  pl: "https://center.ai/pl/cennik/",
  en: "https://center.ai/pl/cennik/"
};
export default {
  name: "AccountTypeSelectionPage",
  components: {
    ChooseLanguage
  },
  methods: {
    goToSignUp() {
      const language = this.$store.state.settings.selectedLocale;
      const contactUrl = PRICING_URLS[language] || PRICING_URLS["pl"];

      window.open(contactUrl, "_blank");
    },
    goToEmployee() {
      this.$router.push({ name: "session-employee-page" });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pages/accountTypeSelection.scss";

.session__container {
  @media screen and (max-height: $heightBreakpoint) {
    padding-top: $spacing * 6;
    padding-bottom: $spacing * 6;
  }
}

.selection-wrapper {
  padding: 0 $spacing * 12;
  color: $dark-blue-3;

  &__text {
    text-align: center;
    margin: 0;
    font-weight: 400;

    @media screen and (max-height: $heightBreakpoint) {
      margin: $spacing * 3 0;
    }
  }
}

.session__title {
  text-align: center;
  margin-bottom: $spacing * 5;

  @media screen and (max-height: $heightBreakpoint) {
    margin-bottom: $spacing * 3;
  }
}

.selection-options {
  display: flex;
  gap: $spacing * 2;
  margin: $spacing * 4.5 0;

  @media screen and (max-height: $heightBreakpoint) {
    margin: $spacing * 2.25 0;
  }
}

.option-card {
  border-radius: 8px;
  border: 2px solid $gray-600;
  padding: $spacing * 2;
  transition-property: transform, border-color;
  transition-duration: 0.4s;
  cursor: pointer;
  width: 100%;

  @media screen and (max-height: $heightBreakpoint) {
    .option-card__title {
      margin: $spacing 0;
    }
  }

  &__image {
    img {
      width: 100%;
    }
  }

  &__title {
    text-align: center;
    margin: $spacing * 2 0;
    font-weight: 600;

    &--highlighted {
      color: $primary;
    }
  }

  &__text {
    font-weight: 400;
  }

  &:hover {
    transform: translateY(-4px);
    border-color: $primary;
  }
}
.submit-button {
  margin-top: $spacing * 4.5;

  @media screen and (max-height: $heightBreakpoint) {
    margin-top: $spacing * 2;
  }
}
</style>
